import {IController, IScope} from "angular";
import * as angular from "angular";

export class planningRoutesQueryListItemCtrl implements IController {
  routeId: any;
  isSelected: boolean;
  isChecked: boolean;
  onSelect: Function;
  onCheck: Function;

  constructor(private $planningRoutes, private $scope: IScope) {
  }

  $onInit() {
    if (this.routeId) {
      this.$planningRoutes(this.routeId).$bindCtrlToId(this.$scope, this, 'route', 'routeId');
    }
  };

  $onChanges(changes) {
    if (changes.routeId && !changes.routeId.isFirstChange()) {
      this.$onInit();
    }
  };
}

angular
  .module('bringoz.admin.lean-planning')
  .component('planningRoutesQueryListItem', {
    bindings: {
      routeId: '<',
      isSelected: '<',
      isChecked: '<?',
      onSelect: '&',
      onCheck: '&'
    },
    template: require('./planning-routes-query-list-item.html').default,
    controller: planningRoutesQueryListItemCtrl
  });
